import type { FetchQueryOptions, QueryClient } from '@tanstack/react-query';

import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';
import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type ICianApiSiteV1GetUserDataByRequestResponse } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

import { type QueryError, type QueryKey, getQueryKey } from './internal/config';
import { fetchCianApiSiteV1GetUserDataByRequestService } from './internal/fetchService';

export class FetchGetUserLoadService {
  private readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public prefetchQuery<TData = ICianApiSiteV1GetUserDataByRequestResponse>(
    dependencies: IQueryStateAppContext,
    options?: FetchQueryOptions<ICianApiSiteV1GetUserDataByRequestResponse, QueryError, TData, QueryKey>,
  ): Promise<void> {
    return this.queryClient.prefetchQuery<ICianApiSiteV1GetUserDataByRequestResponse, QueryError, TData, QueryKey>({
      queryFn: () => fetchCianApiSiteV1GetUserDataByRequestService(dependencies),
      queryKey: getQueryKey(),
      ...options,
    });
  }

  public getQueryData(): ICianApiSiteV1GetUserDataByRequestResponse | null {
    return extractUndefined(this.queryClient.getQueryData<ICianApiSiteV1GetUserDataByRequestResponse>(getQueryKey()));
  }

  public setQueryData(
    updater: ICianApiSiteV1GetUserDataByRequestResponse,
  ): ICianApiSiteV1GetUserDataByRequestResponse | null {
    return extractUndefined(
      this.queryClient.setQueryData<ICianApiSiteV1GetUserDataByRequestResponse>(getQueryKey(), updater),
    );
  }
}
